const ITEMS = [
  "ASSESS",
  "BUILD",
  "GROW",
  "SCALE",
  "7-DAY MONEY-BACK GUARANTEE",
  "STRATEGY",
  "BRANDING",
  "AUTOMATION",
  "GROWTH",
];

const Row = ({ ariaHidden = false }) => (
  <div aria-hidden={ariaHidden} className="flex items-center shrink-0">
    {ITEMS.map((item, i) => (
      <span key={`${item}-${i}`} className="flex items-center">
        <span
          className={`font-display font-bold text-2xl sm:text-4xl lg:text-5xl tracking-tight px-6 sm:px-10 whitespace-nowrap ${
            i % 3 === 1
              ? "text-emerald-500/50"
              : "text-gold/40"
          }`}
        >
          {item}
        </span>
        <span className="w-2 h-2 rotate-45 bg-gold/30 shrink-0" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div className="relative py-8 sm:py-12 border-y border-slate-800/70 overflow-hidden marquee-mask bg-obsidian-900/40">
    <div className="flex w-max animate-marquee">
      <Row />
      <Row ariaHidden />
    </div>
  </div>
);

export default Marquee;
